import { getSearchParams } from './url-handler'

const win: any = window
const u: string = win.navigator.userAgent

export function callNative(params = {}): void {
  const { system } = getUa()
  try {
    if (system === 'ios') {
      win.webkit.messageHandlers.app.postMessage(JSON.stringify(params))
    } else if (system === 'android') {
      win.app.webcall(JSON.stringify(params))
    }
  } catch (e) {
    console.error('不能识别该操作系统！')
  }
}

export function getSystem(): string {
  let system: string = 'unknown'
  if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
    system = 'android'
  } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    system = 'ios'
  }
  return system
}

function isApp(ua: string): boolean {
  const str = u.toLowerCase()
  return str.indexOf('huolala') >= 0 || ua === 'hll_uapp'
}

function getType(ua: string): string {
  let type = ''
  if (/MicroMessenger/i.test(u)) {
    const wx = win.wx || ''
    if (/miniProgram/i.test(u)) {
      // 微信小程序
      type = 'weapp'
    } else if (wx && wx.miniProgram) {
      wx.miniProgram.getEnv((res: any) => {
        type = res.miniprogram ? 'weapp' : 'weaccount'
      })
    } else {
      type = 'weaccount'
    }
  } else if (/AlipayClient/i.test(u)) {
    // 支付宝
    type = 'alipay'
  } else if (ua === 'quick_app') {
    // 快应用
    type = 'quickapp'
  } else if (isApp(ua)) {
    // 货拉拉app
    type = 'app'
  } else {
    type = 'web'
  }
  return type
}

function getName(ua = ''): string {
  let name = ''
  if (ua === 'wxa') {
    name = 'weapp_hy'
  } else if (ua === 'bjwxa') {
    name = 'weapp_bj'
  } else if (ua === 'alipay') {
    name = 'alipay_hy'
  } else if (ua === 'bjali') {
    name = 'alipay_bj'
  } else if (u.indexOf('huolala_app_user') > -1) {
    name = 'app_user'
  } else if (u.indexOf('huolala_app_driver') > -1) {
    name = 'app_driver'
  } else if (u.indexOf('huolala_app_euser') > -1) {
    name = 'app_euser'
  } else {
    name = 'unknow'
  }
  return name
}

export function getUa() {
  const params = getSearchParams() || {}
  const { ua } = params
  const system = getSystem() // 判断操作系统
  const type = getType(ua as string) // 判断客户端类型
  const name = getName(ua as string) // 判断客户端应用

  return {
    system,
    type,
    name,
  }
}

export function postMessage(params: {
  action: 'paymentResult' | 'cashierOff' | 'recharge' | 'resizeParent' | 'processing'
  status?: number
  width?: number
  height?: number
}): void {
  if (window.opener) window.opener.postMessage(params, '*')
  if (window.parent) window.parent.postMessage(params, '*')
}
